import { DocManager, type DocManagerOptions } from './docManager';

/**
 * The app's single `DocManager`. Created lazily so tests (and any future SSR) can install
 * their own before the first hook runs.
 */
let instance: DocManager | null = null;

export function getDocManager(): DocManager {
  instance ??= new DocManager();
  return instance;
}

/** Replaces the singleton — tests and Storybook-style harnesses only. */
export function setDocManager(manager: DocManager | null): void {
  if (instance && instance !== manager) instance.destroy();
  instance = manager;
}

export function createDocManager(options?: DocManagerOptions): DocManager {
  return new DocManager(options);
}
